<template>
  <div>
    <v-text-field
      id="vod_commission_percentage"
      :label="$t('VOD commission percentage (%)')"
      name="vod_commission_percentage"
      type="text"
      :rules="[rules.inBetween(0, 100, company.vod_commission_percentage)]"
      v-model="company.vod_commission_percentage"
      color="saPrimary"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
         <div class="greyDarken3--text body-1">
            {{ $t('vod.admin.company.commission_percentage.tooltip') }}
          </div>
        </v-tooltip>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import i18n from "@/i18n";
import rules from "@/validation";
import DEFINES from "@/defines";

export default {
  name: "AdminCompanyProfileVodSetting",
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data() {
    return { rules };
  },
  watch: {
    company: {
      handler: function () {
        this.$emit("update:company", this.company);
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>
